import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerInput } from '../../models/customer.model';
import { CustomerService } from '../../services/customer.service';
import { Subscription } from 'rxjs';
import { AlertController } from '@ionic/angular';
import { CookieService } from 'ngx-cookie-service';
import { StorageService } from '../../services/storage.service';
import { LOCAL_STORAGE } from '../../constants/local-storage.constants';
import { SimpayxOrder } from '../../models/simpayx-order.model';
import { SimpayxOrderService } from '../../services/simpayx-order.service';
import { plainToClass } from 'class-transformer';

@Component({
  selector: 'simpayx-profile-options',
  templateUrl: './profile-options.component.html',
  styleUrls: ['./profile-options.component.scss'],
})
export class ProfileOptionsComponent implements OnInit {
  profileImage: any;
  customerDetails: CustomerInput;
  customerServiceSubscription: Subscription;
  restaurantHomePageURL: string;
  logisticHomePageURL: string;
  simpayxOrder: SimpayxOrder;

  constructor(
    public router: Router,
    private customerService: CustomerService,
    public alertController: AlertController,
    private cookie :CookieService,
    private storageService: StorageService,
    private simpayxOrderService: SimpayxOrderService
  ) {}

  ngOnInit() {
    this.getCustomerDetails();
  }

  async navigateToRoute(url: string) {
    // await this.menuController.close();
    this.router.navigate([url]);
  }

  getCustomerDetails() {
    this.customerServiceSubscription = this.customerService
      .getCustomerAsObservable()
      .subscribe((result: CustomerInput) => {
        console.log(result);
        this.customerDetails = result;
        if (this.customerDetails?.id && this.customerDetails.profileImageUrl) {
          this.profileImage = this.customerDetails.profileImageUrl;
        } else {
          this.profileImage = './assets/icon/Avatar.png';
        }
      });
  }

  async logoutAlert() {
		const alert = await this.alertController.create({
			header: "Alert",
			subHeader: "Are you sure you want to logout?",
			buttons: [
				{
					text: "Cancel",
					role: "cancel",
					handler: () => {
						console.log("Alert canceled");
					},
				},
				{
					text: "OK",
					role: "confirm",
					handler: () => {
						console.log("Alert confirmed");
						this.logout();
					},
				},
			],
		});

		await alert.present();
	}

	logout() {
		this.cookie.deleteAll();
		let customer: CustomerInput = new CustomerInput(
			"",
			"",
			"",
			"",
			"",
			"",
			"",
			"",
			[],
		);
		this.customerService.setCustomerDetails(customer);
		this.storageService.removeValue(LOCAL_STORAGE.SESSION_ID);
		this.storageService.removeValue(LOCAL_STORAGE.SAVED_CARDS);
		this.storageService.setLocalStorageData(
			LOCAL_STORAGE.CUSTOMER_DETAILS,
			JSON.stringify(customer),
		);
		// this.menuController.close();
		console.log(window.location.href);
		// if (window.location.href.includes("simpayx/order-status")) {
		// 	console.log(this.business);
		// 	window.location.href = `https://restaurants.simpayx.com/simpayx/pickup?merchantId=${this.business.merchantId}&businessId=${this.business.id}`;
		// } else if (window.location.href.includes("customerId")) {
		// 	window.location.href = `https://restaurants.simpayx.com/simpayx/pickup?merchantId=${this.business.merchantId}&businessId=${this.business.id}`;
		// }
	}


  getBusinessIdMerchantIdFromLocal() {
    const businessId = this.storageService.getLocalStorageData(
      LOCAL_STORAGE.BUSINESS_VALUES
    ).businessId;
    const merchantId = this.storageService.getLocalStorageData(
      LOCAL_STORAGE.BUSINESS_VALUES
    ).merchantId;
    const restaurantbaseUrl = 'simpayx/restaurant';
    const logisticbaseUrl = 'simpayx/logistic';
    const queryParams = `merchantId=${merchantId}&businessId=${businessId}`;
    const currentUrl = this.router.url;

    this.restaurantHomePageURL = `${restaurantbaseUrl}?${queryParams}`;
    this.logisticHomePageURL = `${logisticbaseUrl}?${queryParams}`
    if(currentUrl.includes('restaurant')){
      window.location.href = this.restaurantHomePageURL;
    }
    else{
      window.location.href = this.logisticHomePageURL;
    }
    
  }

  getOrder() {
    this.simpayxOrderService.getOrderSubscription().subscribe((result: any) => {
      if (result) {
        this.simpayxOrder = plainToClass(SimpayxOrder, result);
      }
    });
  }

  getHome() {
    if (
      this.storageService.getLocalStorageData(LOCAL_STORAGE.BUSINESS_VALUES)
    ) {
      this.getBusinessIdMerchantIdFromLocal();
    } else {
      this.getOrder();
      const merchantId = this.simpayxOrder.merchantId;
      const businessId = this.simpayxOrder.businessInfo.businessId;
      // this.restaurantHomePageURL = `simpayx/restaurant?merchantId=${merchantId}&businessId=${businessId}`;
      this.logisticHomePageURL = `simpayx/logistic?merchantId=${merchantId}&businessId=${businessId}`;
      window.location.href = this.logisticHomePageURL;
    }
  }

  ngOnDestroy() {
    if (this.customerServiceSubscription) {
      this.customerServiceSubscription.unsubscribe();
    }
  }
}
